import Vue from 'vue';
import Utils from '../../utils';
import flash from '../../flash';
import Panel from '../../panels';
import ActivityEditor from '../activity_editor';
import { PickerPluginDrive } from '../../picker';
import Quill, { ImageAttribute } from '../../components/quill.extended';
import quillExtendedFormulas from '../quillExtendedFormulas.js';
import { CanvasPopupRenderer, ScreenRecorderRenderer } from '../../../shared/reactLoader';

import katex from 'katex';
window.katex = katex;

const Parchment = Quill.import('parchment');
const Delta = Quill.import('delta');

Vue.component('editor-attachment', {
  props: ['attachment', 'locked'],
  methods: {
    removeAttachment: function () {
      this.$emit('remove', this.attachment);
    },
  },
  mounted: function () {},
  computed: {
    classForType: function () {
      if (this.attachment.mime_type.match(/image/)) {
        return 'lp--activityEditorAttachmentItemImage';
      } else {
        return 'lp--activityEditorAttachmentItemObject';
      }
    },
    truncatedFileName: function () {
      return this.attachment.filename.substr(0, 20) + '...';
    },
  },
  template: `
    <div class="lp--activityEditorAttachmentItem" v-bind:class="classForType">
      <a v-bind:href="attachment.url" target="_blank">
        <div class="lp--activityEditorAttachmentLabel">
          {{attachment.filename}}
        </div>
      </a>
      <span tabindex="0" v-if="!locked" v-on:click.stop="removeAttachment" v-on:keyup.enter="removeAttachment" class="lp--activityEditorAttachmentRemove"></span> 
    </div>
  `,
});

Vue.component('editor-recorder-toolbar', {
  template: `
    <div class="lp--activityEditorRecorderToolbar"></div>
  `,
});

Vue.component('editor-recorder', {
  props: ['options', 'camera', 'type'],
  mounted: function () {
    this.cameraTag = (window.editor || window.viewer || window.tp).options.cameraTag;
    this.templates = $('#camera-tag-custom-components > div').clone();
    if (!this.options.commentContext) {
      CameraTag.observe('camera', 'published', (recording) => {
        if (this.type == 'video') {
          this.$emit('fileAdded', {
            url: recording.medias.qvga_mp4,
            thumb: recording.medias.qvga_thumb,
            filename: recording.uuid,
            mime_type: 'video/mp4',
            source: ActivityEditor.AttachmentSource.Webcam,
            uuid: recording.uuid,
            state: 'published',
          });
        } else {
          this.$emit('fileAdded', {
            url: recording.medias.mp3,
            thumb: recording.medias.negative_waveform,
            filename: recording.uuid,
            mime_type: 'audio/mp3',
            source: ActivityEditor.AttachmentSource.Microphone,
            uuid: recording.uuid,
            state: 'published',
          });
        }
      });

      CameraTag.observe('camera', 'processed', (recording) => {
        this.$emit('recordingProcessed', recording);
      });

      $(this.$el).on(Utils.interactionEvent, '.lp--js-publish', () => {
        (CameraTag.cameras['camera'] || CameraTag.microphones['camera']).publish();
      });
    } else {
      $(this.$el).on(Utils.interactionEvent, '.lp--js-publish', (ev) => {
        this.$emit('recordingDone', ev);
      });
    }

    $(this.$el).on(Utils.interactionEvent, '.lp--js-closeRecorder', () => {
      this.$emit('discardType');
    });

    CameraTag.setup();
  },
  beforeDestroy: function () {
    $('#camera-tag-custom-components').append(this.templates);
  },
  destroyed: function () {
    if (this.type == 'video') {
      CameraTag.cameras['camera'].destroy();
    } else if (CameraTag.microphones['camera']) {
      CameraTag.microphones['camera'].destroy();
    }
  },
  methods: {
    forcePlay: function () {
      (CameraTag.cameras['camera'] || CameraTag.microphones['camera']).play();
      this.displayForcedPreview = false;
    },
    publishRecording: function () {
      return new Promise((resolve) => {
        let publish = (recording) => {
          if (this.type == 'video') {
            resolve({
              url: recording.medias.qvga_mp4,
              thumb: recording.medias.qvga_thumb,
              filename: recording.uuid,
              mime_type: 'video/mp4',
              source: ActivityEditor.AttachmentSource.Webcam,
            });
          } else {
            resolve({
              url: recording.medias.mp3,
              thumb: recording.medias.negative_waveform,
              filename: recording.uuid,
              mime_type: 'audio/mp3',
              source: ActivityEditor.AttachmentSource.Microphone,
            });
          }
          $('.lp--activityEditorRecorder').hide();
          resolve();
        };

        CameraTag.observe('camera', 'published', publish);

        if (this.type == 'video') {
          CameraTag.cameras['camera'].publish();
        } else {
          CameraTag.microphones['camera'].publish();
        }

        CameraTag.observe('camera', 'processed', (recording) => {
          this.$emit('recordingProcessed', recording);
        });
      });
    },
    discard: function () {
      if (!this.options.commentContext) {
        this.$emit('toggleRecorder', false);
      } else {
        this.$emit('discardType');
      }
    },
    i18n: function (str) {
      return i18n.__(str);
    },
  },
  computed: {
    userMetadata: function () {
      let userData = Utils.getCurrentUserData();
      return JSON.stringify({ userUUID: userData.uuid });
    },
    appId: () => {
      return (window.editor || window.viewer || window.tp).options.cameraTag.appId;
    },
  },
  data: function () {
    return {
      displayForcedPreview: false,
    };
  },
  template: `
    <div class="lp--activityEditorRecorder">
      <a href="#" class="lp--closeButton" v-on:click="discard" v-bind:title="i18n('app_close')"></a>
      <div class="lp--activityEditorRecorderPreview">
        <div tabindex="0" id='camera-force-preview' v-if="displayForcedPreview" v-on:click="forcePlay" v-on:keyup.enter="forcePlay">
          <h3>{{i18n('camera_tag.forced_preview')}}</h3>
        </div>
        <camera v-if="type == 'video'" v-bind:data-metadata="userMetadata" :data-app-id="appId" data-minlength='3' data-maxlength="600" data-pre-roll-length="3" data-autopreview="false" id='camera' data-sources="record"></camera>
        <microphone v-if="type == 'audio'" v-bind:data-metadata="userMetadata" :data-app-id="appId" data-minlength="1" data-maxlength="600" data-pre-roll-length="3" data-autopreview="false" id='camera' data-sources='record'></microphone>
      </div>
    </div>
  `,
});

Vue.component('editor-file-picker', {
  props: {
    options: {},
    active: {
      default: false,
    },
    isComment: {
      default: false,
    },
    hideTools: false,
  },
  methods: {
    uploadWebcam: function () {
      this.$emit('useRecorder', 'video');
    },
    uploadAudio: function () {
      this.$emit('useRecorder', 'audio');
    },
    showFileDialog: function (ev) {
      if (!this.uploading) {
        this.uploading = true;
        $(ev.target).blur();
        this.mountFileUpload();
        $(this.$el.querySelector('.lp--js-invisibleFileField')).trigger('click');
      }
    },
    i18n: function (str) {
      return i18n.__(str);
    },
    getTabIndex: function () {
      return this.hideTools ? -1 : 0;
    },
    mountFileUpload: function () {
      if (!this.options.locked) {
        let el = this.$el.querySelector('.lp--js-invisibleFileField');
        let that = this;
        this.options.upload.formData.client = 'pr2';
        this.options.upload.formData.protected = '0';
        this.options.upload.formData.public = '1';
        this.options.upload.formData.enforce_file = '1';
        this.options.upload.formData.user_uuid = Utils.getCurrentUserData().uuid;
        $(el)
          .fileupload({
            headers: this.options.upload.headers,
            url: this.options.upload.url + 'upload',
            paramName: 'file',
            formData: this.options.upload.formData,
            dataType: 'json',
            autoUpload: true,
            dropZone: null,
          })
          .bind('fileuploadfail', function (e, data) {
            that.$emit('fileUploadFail', data);
            this.uploading = false;
          })
          .bind('fileuploaddone', function (e, data) {
            that.$emit('fileUploadDone', data);
            this.uploading = false;
          });
      }
    },
  },
  template: `
  <div class="lp--activityEditorUploadContainer">
    <template v-if="!hideTools">
      <template v-if="!options.locked && !isComment">{{i18n('editor_add_document_text')}}</template>
      <div class="lp--activityEditorUploadWrapper" v-if="!options.locked" v-bind:title="i18n('editor_tooltip_upload_file')">
        <div v-bind:tabindex="getTabIndex()" class="lp--activityEditorUploadOption lp--activityEditorUploadFile" v-on:click="showFileDialog" v-on:keyup.enter="showFileDialog">
          <input type="file" class="lp--js-invisibleFileField" />
        </div>
        <button class="lp--activityEditorUploadOption lp--activityEditorUploadVideo" v-if="options.commentContext" v-on:click.stop="uploadWebcam('video')" v-bind="{disabled: options.locked, title: i18n('editor_tooltip_record_video')}">&nbsp;</button>
        <button class="lp--activityEditorUploadOption lp--activityEditorUploadAudio" v-if="options.commentContext" v-on:click.stop="uploadAudio('audio')" v-bind="{disabled: options.locked, title: i18n('editor_tooltip_record_audio')}">&nbsp;</button>
      </div>
      <activity-editor-locked-notification v-else />
    </template>
  </div>
  `,
});

Vue.component('editor-texteditor', {
  props: ['content', 'bust', 'options', 'pendingFileInsert', 'type', 'uuid', 'isTeacher', 'state', 'hasattachments'],
  template: `
    <div class="lp--activityEditor" :isTeacher="this.isTeacher" v-bind:class="{'student': !this.isTeacher, 'has-attachments': this.hasattachments }" data-selection-inert="1">
      <div class="lp--activityEditorArea lp--js-editor"></div>
      <input type="file" class="lp--js-invisibleFileField" />
    </div>
  `,
  computed: {
    selectionType: function () {
      switch (this.type) {
        case 'task':
        case 'group':
          return 'taskreport';
        case 'qa':
          return 'quizanswer';
        case 'evaluation':
          return 'evaluationreport';
        case 'logbook':
        case 'noticeboard':
          return 'blogpost';
      }
    },
  },
  methods: {
    blur: function () {
      if (this.editor) {
        this.editor.blur();
      }
    },
    focus: function () {
      if (this.editor) {
        this.editor.focus();
        if (this.content) {
          this.editor.setSelection(this.content.length, 0);
        }
      }
    },
    addAttachment: function () {
      $(this.$el.querySelector('.lp--js-invisibleFileField')).trigger('click');
    },
    uploadRecording: function (type) {
      $(document.getElementsByClassName('content-panel')[0]).scrollTop(0, 0);
      window.currentRange = this.editor.getSelection(true);
      this.$emit('useRecorder', type);
    },
    disable: function () {
      this.editor.enable(false);
    },
    enable: function () {
      this.editor.enable(true);
    },
    i18n: function (str) {
      return i18n.__(str);
    },
    toggleToolBarButtons: function () {
      $('.ql-toolbar *').prop('disabled', true);
      $('.ql-toolbar.show *').prop('disabled', false);
      $('.ql-toolbar .ql-picker-label').attr('tabindex', -1);
      $('.ql-toolbar.show .ql-picker-label').attr('tabindex', 0);
    },
    toggleToolbar: function (force, editor) {
      this.toolbarVisible = typeof force === 'boolean' ? force : !this.toolbarVisible;
      let container;
      if (editor) {
        container = $(editor.container).closest('.lp--activityEditorContainer');
      } else {
        if (this.uuid) {
          container = $(`.lp--activityEditorContainer[data-uuid="${this.uuid}"]`);
        }
        if (!container || container.length === 0) {
          container = $(`.lp--activityEditorContainer:not([data-uuid]`);
        }
      }

      if (typeof force === 'boolean') {
        $('.panel-content').find('.ql-toolbar').removeClass('show').attr('aria-hidden', true);
        if (force) {
          container.find('.ql-toolbar').addClass('show').removeAttr('aria-hidden');
        }
      } else {
        container.find('.ql-toolbar, .toolbar-button').toggleClass('show').removeAttr('aria-hidden');
      }
      this.toggleToolBarButtons();
      $('.toolbar-button').blur();
    },
    triggerRecorder: function (type) {
      $(document.getElementsByClassName('content-panel')[0]).scrollTop(0, 0);
      window.currentRange = this.editor.getSelection(true);
      this.$emit('useRecorder', type);
    },
    insertFile: function (file) {
      $('.lp--activityEditorRecorder').hide();
      if (window.currentRange) {
        if (file.source == ActivityEditor.AttachmentSource.Webcam) {
          this.editor.insertEmbed(window.currentRange.index, 'webcam', file, Quill.sources.USER);
        } else if (file.source == ActivityEditor.AttachmentSource.Microphone) {
          this.editor.insertEmbed(window.currentRange.index, 'microphone', file, Quill.sources.USER);
        }
        this.editor.setSelection(window.currentRange.index + 1, Quill.sources.SILENT);
        window.currentRange = null;
      }
      this.$emit('updateContent', this.$el.querySelector('.ql-editor').innerHTML);
    },
    insertItem: function (type) {
      const range = this.editor.getSelection(true);
      switch (type) {
        case 'divider':
          this.editor.insertEmbed(range.index, 'divider', true, Quill.sources.USER);
          this.editor.setSelection(range.index + 1, Quill.sources.SILENT);
          break;
        case 'image':
          $(this.$el.querySelector('.lp--js-invisibleFileField')).attr('accept', 'image/*').trigger('click');
          break;
        case 'upload':
          $(this.$el.querySelector('.lp--js-invisibleFileField')).attr('accept', '*/*').trigger('click');
          break;
        case 'movie':
          $(this.$el.querySelector('.lp--js-invisibleFileField')).attr('accept', 'video/*').trigger('click');
          break;
      }
    },
  },
  mounted: function () {
    this.props = this.$options.propsData;
    this.toolbarVisible = false;
    this.useAutoSave = this.options.autoSave && this.options.autoSave.autoSaveBehaviors.includes(this.type);
    this.currentUploads = {};

    $(window).on('mediaprogress.updated', (ev, data) => {
      const { key, fileName } = data.userMetadata;
      const oembed = $(`.oembed[data-uuid="${key}"]`);
      if (data.status === 'ERROR') {
        flash(i18n.__('media_conversion_failed'));
        oembed.remove();
        const range = this.editor.getSelection(true);
        const fileExtension = Utils.GetFileExtension(fileName);
        embedFile(range, `${this.options.upload.url}${key}.${fileExtension}`, fileName);
      } else {
        const iframe = oembed.find('iframe');
        const reloadIframe = () => iframe.attr('src', iframe.attr('src'));
        if (iframe.length > 0) {
          window.addEventListener('message', (ev) => {
            const progress = ev['data'];
            if (progress === '100') {
              reloadIframe();
            }
          });
          reloadIframe();
        }
      }
    });

    if (!this.options.locked) {
      const el = this.$el.querySelector('.lp--js-invisibleFileField');
      this.options.upload.formData.client = 'pr2';
      this.options.upload.formData.protected = '0';
      this.options.upload.formData.public = '1';
      this.options.upload.formData.user_uuid = Utils.getCurrentUserData().uuid;

      const key = Date.now();

      $(el)
        .fileupload({
          headers: this.options.upload.headers,
          url: this.options.upload.url + 'upload',
          paramName: 'file',
          formData: this.options.upload.formData,
          dataType: 'json',
          autoUpload: true,
          dropZone: null,
        })
        .bind('fileuploadsend', () => {
          const range = this.editor.getSelection(true);
          insertBlot('progress', key, range);
          this.currentUploads[key] = {
            index: range.index,
            node: document.querySelector(`#upload-progress-${key}`),
          };
        })
        .bind('fileuploadfail', (e, data) => {
          this.$emit('fileUploadFail', data);
          const progress = document.querySelector(`#upload-progress-${key}, #conversion-progress-${key}`);
          // The placeholder has been deleted, thus the upload is "cancelled...";
          if (!progress) {
            return;
          }
          removeBlot(progress);
        })
        .bind('fileuploadprogress', (e, data) => {
          const file = data.files[0];
          const progress = this.currentUploads[key].node;
          const percentDone = parseInt((data.loaded / data.total) * 100, 10);
          progress.childNodes[0].innerHTML = percentDone + '%';
          progress.childNodes[1].style.width = percentDone + '%';
          if (percentDone === 100 && fileRequiresConversion(file.name)) {
            setTimeout(() => {
              const range = this.editor.getSelection(true);
              removeBlot(progress);
              insertBlot('conversion', key, range, 'image_media_processing_message');
            }, 1000);
          }
        })
        .bind('fileuploaddone', (e, data) => {
          const uploadUrl = this.options.upload.url;
          const { filemime, filename, oembed, original_filename } = data.result;
          embedUploadedFile({
            url: uploadUrl + filename,
            uuid: filename.split('.')[0],
            fileName: original_filename,
            mimeType: filemime,
            oembed,
            key,
            source: ActivityEditor.AttachmentSource.Upload,
          });
        });
    }

    const removeBlot = (blotInstance) => {
      const blot = blotInstance && Quill.find(blotInstance);
      const index = blot && this.editor.getIndex(blot);
      blot &&
        this.editor.deleteText({
          index,
          length: 1,
          source: Quill.sources.SILENT,
        });
    };

    const insertBlot = (blotType, key, range, textKey) => {
      this.editor.insertEmbed(range.index, blotType, key, Quill.sources.SILENT);
      if (textKey) {
        $(`#${blotType}-progress-${key} .lp--activityEditorProgressLabel`).html(i18n.__(textKey));
      }
      return blotType === 'progress' ? $(`#upload-progress-${key}`) : $(`#${blotType}-progress-${key}`);
    };

    const isLinkedFile = (source) =>
      source === ActivityEditor.AttachmentSource.Dropbox ||
      source === ActivityEditor.AttachmentSource.Drive ||
      source === ActivityEditor.AttachmentSource.OneDrive;

    const usesProgressBlot = (source) => !isLinkedFile(source) && source !== ActivityEditor.AttachmentSource.DropPaste;

    const fileRequiresConversion = (fileName) => Utils.isOfFileType(fileName, ['heic', 'heif']);

    const embedFile = (range, url, fileName) => {
      const embedType = Utils.fileIsEmbedable(url) ? 'oembed' : 'file';
      this.editor.insertEmbed(range.index, embedType, { url, fileName }, Quill.sources.USER);
    };

    const embedUploadedFile = (data) => {
      const { url, uuid, fileName, mimeType, oembed, source, key } = data;

      const range = this.editor.getSelection(true) || { index: 0, length: 0 };
      const index = range.index;
      const progress = key && document.querySelector(`#upload-progress-${key}, #conversion-progress-${key}`);
      if (!progress && usesProgressBlot(source)) {
        return;
      }
      removeBlot(progress);

      if (mimeType.match(/video/)) {
        const locale = $('body').data('user-base-locale');
        const localizedUrl = `${oembed}/${locale}`;
        this.editor.insertEmbed(index, 'oembed', { uuid, url: localizedUrl }, Quill.sources.USER);
      } else if (mimeType.match(/image/)) {
        const image = new Image();
        image.onload = () => {
          this.editor.insertEmbed(index, 'image', url, Quill.sources.USER);
        };
        image.onerror = () => {
          embedFile(range, url, fileName);
        };
        image.src = url;
      } else if (mimeType.match(/audio/)) {
        this.editor.insertEmbed(index, 'audio', { uuid }, Quill.sources.USER);
      } else {
        embedFile(range, url, fileName);
      }

      this.editor.insertText(this.editor.getLength() + 1, '\n', Quill.sources.API);
      this.editor.setSelection(this.editor.getLength() + 1, Quill.sources.API);
    };

    const insertMediaHandler = () => {
      $(this.$el.querySelector('.lp--js-invisibleFileField')).trigger('click');
    };

    const attachmentHandler = () => {
      $(this.$el.querySelector('.lp--js-invisibleFileField')).trigger('click');
    };

    const initializeProgressBlot = ({ size = 0, blot }) => {
      const range = this.editor.getSelection(true);
      const key = Date.now();
      const progressBlot = blot || insertBlot('progress', key, range);
      const onUploadProgress = (progressEvent) => {
        const { loaded, total } = progressEvent;
        const fileSize = total || parseInt(size);
        const percentDone = Math.floor((loaded / fileSize) * 100);
        const progress = percentDone > 100 ? 100 : percentDone;
        progressBlot.find('.lp--activityEditorProgressLabel').text(`${progress}%`);
        progressBlot.find('.lp--activityEditorProgressBar').width(`${progress}%`);
      };
      return { range, key, blot: progressBlot, onUploadProgress };
    };

    const cloudFileHandler = async (url, fileName, source, size, mime_type, options, webViewLink) => {
      let fileUrl = webViewLink;
      let mimeType = mime_type;
      let key, blot, onUploadProgress;
      if (url) {
        ({ blot, key, onUploadProgress } = initializeProgressBlot({ size }));
        const file = await Utils.downloadFile(url, options, onUploadProgress, mime_type);
        ({ onUploadProgress } = initializeProgressBlot({ blot }));
        const data = await Utils.uploadFileToArchivist({ file, onUploadProgress, fileName });
        const fileServiceUrl = Utils.getFileService().url;
        fileUrl = fileServiceUrl + data.filename;
        mimeType = data.filemime;
      }
      embedUploadedFile({
        url: fileUrl,
        fileName,
        source,
        key,
        mimeType,
      });
    };

    const dropboxHandler = () => {
      const options = {
        success: async (files) => {
          const { link, name } = files[0];
          await cloudFileHandler(link, name, ActivityEditor.AttachmentSource.Dropbox);
        },
        cancel: () => {},
        linkType: 'direct',
        multiselect: false,
      };
      Dropbox.choose(options);
    };

    const gdriveHandler = async () => {
      const picker = new PickerPluginDrive(this.options.integrations.drive);
      picker.eventSource.on('file-success', async (ev, file) => {
        const { url, filename, accessToken, webViewLink, size, mime_type } = file;
        const options = { headers: { Authorization: `Bearer ${accessToken}` } };
        await cloudFileHandler(
          url,
          filename,
          ActivityEditor.AttachmentSource.Drive,
          size,
          mime_type,
          options,
          webViewLink,
        );
      });
      picker.choose();
    };

    const onedriveHandler = () => {
      const options = {
        clientId: this.options.integrations.onedrive.client_id,
        action: 'query',
        multiselect: false,
        advanced: {
          queryParameters: 'select=id,name,file,@microsoft.graph.downloadUrl',
          redirectUri: this.options.integrations.onedrive.redirect_uri,
        },
        success: async (response) => {
          const item = response.value[0];
          const url = item['@microsoft.graph.downloadUrl'];
          const fileName = item.name;
          await cloudFileHandler(url, fileName, ActivityEditor.AttachmentSource.OneDrive);
        },
        cancel: () => {},
        error: () => {
          flash(i18n.__('app_error_alert'));
        },
      };
      OneDrive.open(options);
    };

    const recordHandler = (type) => {
      $(document.getElementsByClassName('content-panel')[0]).scrollTop(0, 0);
      window.currentRange = this.editor.getSelection(true);
      this.$emit('useRecorder', type);
    };

    const videoHandler = () => {
      recordHandler('video');
    };

    const audioHandler = () => {
      recordHandler('audio');
    };

    const dividerHandler = () => {
      const range = this.editor.getSelection(true);
      this.editor.insertEmbed(range.index, 'divider', true, Quill.sources.USER);
      this.editor.setSelection(range.index + 1, Quill.sources.SILENT);
    };

    const textSizeHandler = (value) => {
      const range = this.editor.getSelection(true);
      this.editor.formatText(range.index, range.length, 'size', value, Quill.sources.USER);
    };

    const linkHandler = (value) => {
      if (value) {
        const range = this.editor.getSelection(true);
        if (range == null || range.length === 0) {
          flash(i18n.__('toolbar_button_link_no_text_selected'), { type: 'status' });
          return;
        }
        const { tooltip } = this.editor.theme;
        tooltip.edit('link', '');
        tooltip.textbox.placeholder = location.origin;
      } else {
        this.editor.format('link', false);
      }
    };

    const formulaHandler = () => {
      const { tooltip } = this.editor.theme;
      tooltip.edit('formula');
      setTooltipArrowPosition();
    };

    const insertHandler = function (value) {
      this.handlers[value]();
    };

    const undoHandler = () => {
      this.editor.history.undo();
    };

    const canvasHandler = () => {
      const onSave = (svg) => {
        const blob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' });
        pasteAndDropHandler(new File([blob], 'svg'));
      };
      CanvasPopupRenderer.render(onSave);
    };

    const screenRecorderHandler = async () => {
      const onRecording = (recording) => {
        $('.ql-screen_recorder').toggleClass('recording', recording);
      };
      const onRecordingDone = (blob) => {
        pasteAndDropHandler(new File([blob], 'mp4'));
      };
      const permissions = await Utils.getRecordingPermissions();
      ScreenRecorderRenderer.render(onRecording, onRecordingDone, permissions);
    };

    const addLinkClickHandlers = () => {
      const root = $(this.editor.root);
      root.find('a').off('click');
      root.find('a').on(Utils.interactionEvent, (ev) => {
        if ($(ev.target).closest('.lp--activityEditorLinkBox, .file').length > 0) {
          return;
        }
        const { tooltip } = this.editor.theme;
        const url = root.parent().find('.ql-preview').attr('href');
        tooltip.edit('link', url);
        tooltip.textbox.placeholder = location.origin;
        root.parent().find('.ql-editing input')[0].setSelectionRange(url.length, url.length);
        setTooltipArrowPosition();
      });
    };

    const addTooltips = () => {
      const setTooltip = (element, tooltip) => {
        element.attr('title', tooltip);
        element.children('.ql-picker-label').attr('aria-label', tooltip);
      };
      this.editor.options.modules.toolbar.container.forEach((container) => {
        container.forEach((item) => {
          const key = Object.keys(item)[0];
          const keyPrefix = 'toolbar_button_tooltip_';
          if (typeof item === 'object' && typeof item[key] !== 'object') {
            setTooltip(
              $(`.ql-toolbar button.ql-${key}[value="${item[key]}"]`),
              i18n.__(`${keyPrefix}${key}_${item[key]}`),
            );
          } else if (typeof item === 'object' && typeof item[key] === 'object') {
            setTooltip($(`.ql-toolbar span.ql-${key}`), i18n.__(`${keyPrefix}${key}`));
          } else {
            setTooltip($(`.ql-toolbar button.ql-${item}`), i18n.__(`${keyPrefix}${item}`));
            if (!navigator.appVersion.includes('Win')) {
              const tooltip = $(`button.ql-${item}[title*="Ctrl"]`).attr('title');
              if (tooltip) {
                setTooltip($(`button.ql-${item}`), tooltip.replace('Ctrl', 'Cmd'));
              }
            }
          }
        });
      });
    };

    const toolbarIcons = Quill.import('ui/icons');
    const addToolbarIconCustomizations = () => {
      toolbarIcons['divider'] =
        `<svg viewBox="0 0 18 18"><path class="ql-fill" d="M15,12v2a.99942.99942,0,0,1-1,1H4a.99942.99942,0,0,1-1-1V12a1,1,0,0,1,2,0v1h8V12a1,1,0,0,1,2,0ZM14,3H4A.99942.99942,0,0,0,3,4V6A1,1,0,0,0,5,6V5h8V6a1,1,0,0,0,2,0V4A.99942.99942,0,0,0,14,3Z" /><path class="ql-fill" d="M15,10H3A1,1,0,0,1,3,8H15a1,1,0,0,1,0,2Z" /></svg>`;
      toolbarIcons['audio'] =
        `<svg viewBox="0 0 40 40"><path class="ql-fill" d="M20,22.33a5.69,5.69,0,0,0,5.69-5.69V9.39a5.69,5.69,0,1,0-11.38,0v7.25A5.69,5.69,0,0,0,20,22.33Z"/><path class="ql-fill" d="M30.47,14.22h0a2,2,0,0,0-2,2,8.5,8.5,0,0,1-17,0,2,2,0,1,0-3.95,0A12.46,12.46,0,0,0,17.74,28.43v5.76h0a2.24,2.24,0,0,0,4.48,0h0V28.43A12.46,12.46,0,0,0,32.44,16.19,2,2,0,0,0,30.47,14.22Z"/></svg>`;
      toolbarIcons['video'] =
        `<svg viewBox="-1.3 -1.3 15 12"><rect class="ql-fill" width="9.589" height="9.209" rx="1.987" /><path class="ql-fill" d="M4008.281,1392.721l3.514-2.582c.343-.228.885-.047.885.293v5.4c0,.367-.623.533-.935.252l-3.514-2.8a.312.312,0,0,1,.05-.561Z" transform="translate(-4000.296 -1388.528)" /></svg>`;
      toolbarIcons['attachment'] =
        `<svg viewBox="-7 0 35 35"><path class="ql-stroke" d="M12.57,9.15,5.28,28a3.74,3.74,0,0,0,2,5h0A3.61,3.61,0,0,0,12,30.6L20.09,9.66a6,6,0,0,0-3.42-7.75h0A6,6,0,0,0,8.92,5.33L1.5,24.45"/></svg>`;
      toolbarIcons['dropbox'] =
        `<svg viewBox="-4 -4 55 55"><polygon class="ql-fill" points="13.9,0 0,9.1 9.6,16.8 23.6,8.1"/><polygon class="ql-fill" points="0,24.5 13.9,33.6 23.6,25.4 9.6,16.8"/><polygon class="ql-fill" points="23.6,25.4 33.4,33.6 47.3,24.5 37.7,16.8"/><polygon class="ql-fill" points="47.3,9.1 33.4,0 23.6,8.1 37.7,16.8"/><polygon class="ql-fill" points="23.7,27.2 13.9,35.3 9.7,32.6 9.7,35.6 23.7,44 37.6,35.6 37.6,32.6 33.4,35.3"/></svg>`;
      toolbarIcons['gdrive'] =
        `<svg viewBox="-7 -9 65 65"><polygon class="ql-fill" points="35.2,0 18.1,0 34.5,27.8 51.6,27.8"/><polygon class="ql-fill" points="51.6,29.8 19,29.8 10.5,44.3 43.1,44.3"/><polygon class="ql-fill" points="25.1,15.8 16.4,1.1 0,29 8.7,43.6"/></svg>`;
      toolbarIcons['textsize'] =
        `<svg viewBox="8 7 32 32"><path class="ql-fill" d="M34,12H20c-1.135,0-3,0-3,0v5c0,0,0,0,0.996,0C18,15,19.229,14,21,14h4v18c0,1-2,1-3,1c0,1,0,1,0,1h10c0,0,0,0,0-1c-1,0-3,0-3-1V14h4c1.77,0,3,1,3.004,3C37,17,37,17,37,17v-5C37,12,35.135,12,34,12z"/><path class="ql-fill" style="opacity:0.5;" d="M20.5,23h-7c-0.567,0-1.5,0-1.5,0v2.5c0,0,0,0,0.498,0C12.5,24.5,13.115,24,14,24h2v9c0,0.5-1,0.5-1.5,0.5c0,0.5,0,0.5,0,0.5h5c0,0,0,0,0-0.5c-0.5,0-1.5,0-1.5-0.5v-9h2c0.885,0,1.5,0.5,1.502,1.5c0.498,0,0.498,0,0.498,0V23C22,23,21.067,23,20.5,23z"/></svg>`;
      toolbarIcons['onedrive'] =
        `<svg viewBox="-15 -60 330 330"><g transform="translate(296.64282,-173.95523)"><g transform="translate(222.85714,-11.428576)"><path class="ql-fill" d="m -419.49993,365.93502 c -18.47931,-4.6173 -28.77445,-19.30626 -28.80701,-41.10136 -0.0104,-6.9681 0.49376,-10.3069 2.2331,-14.78872 4.26362,-10.98614 15.55175,-19.27443 30.40561,-22.32524 7.3912,-1.51808 9.6683,-3.14802 9.6683,-6.92063 0,-1.18378 0.8797,-4.70915 1.9548,-7.83417 4.8844,-14.19664 13.9278,-26.03145 23.5912,-30.87276 10.1136,-5.06692 15.2197,-6.20959 27.454,-6.1439 17.3752,0.0933 26.0437,3.86233 38.1679,16.59515 l 6.6679,7.00266 5.9735,-2.06722 c 28.9108,-10.0052 57.732,7.02633 60.0552,35.48894 l 0.6355,7.78629 5.6932,2.0398 c 16.2589,5.82539 23.9011,18.05787 22.5157,36.0398 -0.906,11.75948 -6.4042,21.14812 -15.1143,25.80891 l -4.0947,2.19109 -90.9999,0.17534 c -69.9288,0.13474 -92.1578,-0.11394 -96,-1.07398 z" /><path class="ql-fill" d="m -487.71853,353.36403 c -10.78803,-2.56384 -22.21903,-12.09222 -27.5793,-22.9889 -3.04063,-6.18117 -3.20213,-7.09029 -3.20213,-18.02547 0,-10.40101 0.25949,-12.06963 2.68006,-17.23407 5.1028,-10.88715 14.87971,-18.75377 27.14681,-21.84266 2.58892,-0.6519 5.02163,-1.69242 5.40602,-2.31227 0.38439,-0.61986 0.81139,-3.99652 0.94887,-7.5037 0.8539,-21.78191 15.14556,-40.97432 35.10144,-47.13807 10.78127,-3.32999 24.32593,-2.51086 36.05253,2.18033 3.7192,1.48788 3.3004,1.80688 11.1643,-8.50453 4.6506,-6.09809 14.0477,-13.68221 21.7397,-17.54555 8.3016,-4.16947 16.9354,-6.0904 27.2603,-6.06509 28.8573,0.0708 53.7275,18.12068 62.924,45.66805 2.9383,8.80156 2.7918,11.26655 -0.674,11.3392 -1.5125,0.0317 -5.8462,0.86464 -9.6305,1.85097 l -6.8805,1.79333 -6.2783,-6.27821 c -17.7018,-17.70181 -46.5914,-21.52795 -71.1505,-9.42317 -9.8115,4.83593 -17.6958,11.77857 -23.6512,20.82628 -4.2457,6.45035 -9.659,18.48366 -9.659,21.47126 0,2.11952 -1.7162,3.17862 -9.0456,5.58229 -22.69211,7.44184 -35.93693,24.62822 -35.92778,46.61961 0.003,8.00419 2.06453,17.79824 4.92624,23.40766 1.07878,2.11458 1.6807,4.12542 1.3376,4.46852 -0.87745,0.87745 -29.10623,0.58172 -33.00906,-0.34581 z"/></g></g></svg>`;
      toolbarIcons['insert'] =
        `<svg viewBox="-5.5 -5.5 45 45"><g transform="translate(-3849.201 -1837.986)"><path class="ql-fill" d="M3853.946,984.986a17.041,17.041,0,1,0,17.042,17.042A17.042,17.042,0,0,0,3853.946,984.986Zm7.143,19.06h-5.125v5.125a2.018,2.018,0,0,1-4.036,0v-5.125H3846.8a2.018,2.018,0,1,1,0-4.036h5.126v-5.126a2.018,2.018,0,0,1,4.036,0v5.126h5.125a2.018,2.018,0,0,1,0,4.036Z" transform="translate(12.297 853)" /></g></svg>`;
      toolbarIcons['undo'] =
        `<svg viewbox="0 0 18 18"><polygon class="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10"></polygon><path class="ql-stroke" d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"></path></svg>`;
      toolbarIcons['canvas'] =
        `<svg viewBox="0 -6 40 40"><path class="ql-fill ql-stroke" d="M16.71,5A.47.47,0,0,0,16,5L4.19,16.88a.47.47,0,0,0,0,.67l6.18,6.18a.47.47,0,0,0,.67,0L22.89,11.88a.47.47,0,0,0,0-.67Z" /><path class="ql-fill ql-stroke" d="M2.14,19.6a.47.47,0,0,0-.8.25L0,27.36a.47.47,0,0,0,.47.55H.56l7.51-1.33a.47.47,0,0,0,.25-.8Z" /><path class="ql-fill ql-stroke" d="M21.6.14a.47.47,0,0,0-.67,0L18.76,2.3a.47.47,0,0,0,0,.67l6.18,6.18a.47.47,0,0,0,.67,0L27.78,7a.47.47,0,0,0,0-.67Z" /></svg>`;
      toolbarIcons['screen_recorder'] =
        `<svg viewBox="0 -10 95 95"><g><g transform="translate(-4536.642 -1733.827)"><circle cx="16" cy="16" transform="translate(4558.639 1755.606)" class="ql-fill" r="16"/></g><g class="ql-stroke" stroke-linecap="round"><path d="M1.5 49.5v25"/><path d="M1.5 74.5h25"/></g><g class="ql-stroke" stroke-linecap="round"><path d="M26.5 1.5h-25"/><path d="M1.5 1.5v25"/></g><g class="ql-stroke" stroke-linecap="round"><path d="M74.5 26.5v-25"/><path d="M74.5 1.5h-25"/></g><g class="ql-stroke" stroke-linecap="round"><path d="M49.5 74.5h25"/><path d="M74.5 74.5v-25"/></g></g></svg>`;
    };
    addToolbarIconCustomizations();

    const addTextSizeCustomizations = () => {
      const textSizeButton = $(this.editor.container).parent().find('.ql-textsize');
      textSizeButton.find('.ql-picker-item').each((index, item) => {
        const size = item.dataset.value ? item.dataset.value : 'normal';
        item.textContent = i18n.__(`toolbar_button_tooltip_textsize_${size}`);
        item.classList.add(`ql-size-${size}`);
      });
      textSizeButton.addClass('ql-icon-picker');
      textSizeButton.find('.ql-picker-label').html(toolbarIcons['textsize']);
      textSizeButton.on(Utils.tapInteractionEvent, () => {
        const range = this.editor.getSelection(true);
        const rangeFormat = this.editor.getFormat(range.index, range.length);
        if (rangeFormat && rangeFormat['size']) {
          const sizeClass = `ql-size-${rangeFormat['size']}`;
          textSizeButton.find('.ql-picker-item').removeClass('ql-selected');
          textSizeButton.find(`.ql-picker-item.${sizeClass}`).addClass('ql-selected');
        } else {
          textSizeButton.find('.ql-picker-item.ql-size-normal').addClass('ql-selected');
        }
      });
    };

    const addInsertPickerCustomizations = () => {
      const insertPicker = $(this.editor.container).parent().find('.ql-insert');
      insertPicker.addClass('ql-icon-picker');
      insertPicker.find('.ql-picker-label').html(toolbarIcons['insert']).removeClass('ql-active');
      insertPicker.find('.ql-picker-item').each((index, item) => {
        $(item).attr('title', i18n.__(`toolbar_button_tooltip_${item.dataset.value}`));
        $(item).addClass(`ql-${item.dataset.value}`);
        item.innerHTML = toolbarIcons[item.dataset.value];
      });
    };

    const lineBreakMatcher = () => {
      var newDelta = new Delta();
      newDelta.insert({ break: '' });
      return newDelta;
    };

    const clipboard = {
      matchers: [['BR', lineBreakMatcher]],
    };

    const keyboard = {
      bindings: {
        blur: {
          key: 27,
          handler: () => {
            this.editor.blur();
          },
        },
        handleEnter: {
          key: 13,
          handler: (range, context) => {
            if (range.length > 0) {
              this.editor.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
            }
            // Stop formatting as list when hitting enter for an empty item
            if (!context.prefix && context.format.list) {
              delete context.format.list;
              this.editor.removeFormat(range.index, 1);
            }
            const lineFormats = Object.keys(context.format).reduce((lineFormats, format) => {
              if (Parchment.query(format, Parchment.Scope.BLOCK) && !Array.isArray(context.format[format])) {
                lineFormats[format] = context.format[format];
              }
              return lineFormats;
            }, {});
            const previousChar = this.editor.getText(range.index - 1, 1);
            // Earlier scroll.deleteAt might have messed up our selection,
            // so insertText's built in selection preservation is not reliable
            this.editor.insertText(range.index, '\n', lineFormats, Quill.sources.USER);
            if (previousChar === '' || previousChar === '\n') {
              this.editor.setSelection(range.index + 2, Quill.sources.SILENT);
            } else {
              this.editor.setSelection(range.index + 1, Quill.sources.SILENT);
            }
            Object.keys(context.format).forEach((name) => {
              if (lineFormats[name] !== null || Array.isArray(context.format[name]) || name === 'link') {
                return;
              }
              this.editor.format(name, context.format[name], Quill.sources.USER);
            });
          },
        },
        linebreak: {
          key: 13,
          shiftKey: true,
          handler: (range) => {
            const currentLeaf = this.editor.getLeaf(range.index)[0];
            const nextLeaf = this.editor.getLeaf(range.index + 1)[0];

            this.editor.insertEmbed(range.index, 'break', true, 'user');

            // Insert a second break if:
            // At the end of the editor, OR next leaf has a different parent (<p>)
            if (nextLeaf === null || currentLeaf.parent !== nextLeaf.parent) {
              this.editor.insertEmbed(range.index, 'break', true, 'user');
            }

            // Now that we've inserted a line break, move the cursor forward
            this.editor.setSelection(range.index + 1, Quill.sources.SILENT);
          },
        },
        clearNonBreakingSpace: {
          key: 32,
          shiftKey: true,
          ctrlKey: true,
          handler: () => {
            const html = this.editor.container.innerHTML;
            if (html.indexOf('&nbsp;') > -1) {
              const clearedHtml = html.replace(/&nbsp;/g, ' ');
              this.editor.container.innerHTML = clearedHtml;
              this.$emit('updateContent', clearedHtml);
            }
          },
        },
      },
    };

    if (this.options.editorPopup) {
      keyboard.bindings.tab = {
        key: 9,
        handler: () => {
          return true;
        },
      };
    }

    const pasteAndDropHandler = (file, base64Data) => {
      if (!(file instanceof File)) {
        return;
      }

      const { range, key, onUploadProgress } = initializeProgressBlot({});
      const uploadFile = async () => {
        const fileServiceUrl = Utils.getFileServiceUrl();
        const data = await Utils.uploadFileToArchivist({ file, onUploadProgress });

        if (data) {
          const { filemime, filename, original_filename, oembed } = data;
          embedUploadedFile({
            url: fileServiceUrl + filename,
            uuid: filename.split('.')[0],
            fileName: original_filename,
            mimeType: filemime,
            oembed,
            key,
            source: ActivityEditor.AttachmentSource.DropPaste,
          });
        } else if (base64Data) {
          this.editor.updateContents(
            new Delta().retain(range.index).delete(range.length).insert({ image: base64Data }),
            Quill.sources.USER,
          );
          this.editor.setSelection(range.index + 1, Quill.sources.SILENT);
        }
      };

      setTimeout(() => uploadFile(), 1000);
    };

    this.$el.querySelector('.lp--js-editor').innerHTML = this.content || '';

    const popupButtons = ['bold', 'italic', 'underline'];

    const colorPalette = [
      '#000000',
      '#e60000',
      '#ff9900',
      '#ffff00',
      '#008a00',
      '#0066cc',
      '#9933ff',
      '#ffffff',
      '#facccc',
      '#ffebcc',
      '#ffffcc',
      '#cce8cc',
      '#cce0f5',
      '#ebd6ff',
      '#bbbbbb',
      '#f06666',
      '#ffc266',
      '#ffff66',
      '#66b966',
      '#66a3e0',
      '#c285ff',
      '#888888',
      '#a10000',
      '#b26b00',
      '#b2b200',
      '#006100',
      '#0047b2',
      '#6b24b2',
      '#444444',
      '#5c0000',
      '#663d00',
      '#666600',
      '#003700',
      '#002966',
      '#3d1466',
    ];

    const formattingTools = [
      'bold',
      'italic',
      { list: 'ordered' },
      { list: 'bullet' },
      { textsize: ['small', false, 'large', 'huge'] },
      { align: [] },
      { color: colorPalette },
      { background: colorPalette },
    ];
    const insertTools = [
      'link',
      'divider',
      'emoji',
      'formula',
      'image',
      { insert: ['attachment', 'dropbox', 'gdrive', 'onedrive'] },
    ];
    const recordingTools = $(this.$el).hasClass('student')
      ? ['canvas']
      : ['video', 'audio', 'screen_recorder', 'canvas'];
    const undoTools = ['clean', 'undo'];
    const nodeToolbarButtons = [formattingTools, insertTools, recordingTools, undoTools];
    const hubToolbarButtons = [formattingTools, undoTools, insertTools, recordingTools];

    const getPlaceholderText = () => {
      const type = this.props.type;
      const editorType = window.editor && (window.editor.contentEditor.type || window.editor.contentEditor.panel.type);
      if (editorType === Panel.CIRCLE || editorType === Panel.HUB || editorType === 'evaluation') {
        return this.options.placeholder;
      } else if (type === 'task' || type === 'written_quiz') {
        return i18n.__('task_texteditor_placeholder');
      } else if (type === 'logbook') {
        return i18n.__('logbook_texteditor_placeholder');
      } else if (type === 'group') {
        return i18n.__('grouptask_texteditor_placeholder');
      } else if (type === 'noticeboard') {
        return i18n.__('noticeboard_texteditor_placeholder');
      } else {
        return i18n.__('default_texteditor_placeholder');
      }
    };

    this.editor = new Quill(this.$el.querySelector('.lp--js-editor'), {
      theme: this.options.editorPopup ? 'bubble' : 'snow',
      placeholder: getPlaceholderText(),
      readOnly: !this.options.isTeacher && (this.options.locked || this.state === 'done' || this.state === 'accepted'),
      modules: {
        clipboard,
        keyboard,
        formula: true,
        toolbar: this.options.limitedEditor
          ? this.options.editorPopup
            ? popupButtons
            : false
          : {
              container: this.options.useHubToolbar ? hubToolbarButtons : nodeToolbarButtons,
              handlers: {
                image: insertMediaHandler,
                divider: dividerHandler,
                textsize: textSizeHandler,
                link: linkHandler,
                video: videoHandler,
                audio: audioHandler,
                attachment: attachmentHandler,
                dropbox: dropboxHandler,
                gdrive: gdriveHandler,
                onedrive: onedriveHandler,
                formula: formulaHandler,
                insert: insertHandler,
                undo: undoHandler,
                canvas: canvasHandler,
                screen_recorder: screenRecorderHandler,
              },
            },
        imageResize: {
          modules: ['Resize', 'DisplaySize', 'Toolbar', ImageAttribute],
        },
        fileDrop: {
          pasteAndDropHandler,
        },
        'emoji-toolbar': true,
        history: {
          delay: 1000,
          maxStack: 100,
          userOnly: false,
        },
      },
    });

    let { options: windowOptions } = window.editor ? window.editor : window.viewer ? window.viewer : null;

    const formulaOperators = [
      ['^{x}', '^{x}'],
      ['_{x}', '_{x}'],
      ['\\sqrt{x}', '\\sqrt{x}'],
      ['\\underline{\\underline{abc}}', '\\underline{\\underline{abc}}'],
      ['\\cdot', '\\cdot'],
      ['\\xrightarrow[xyz]{abc}', '\\xrightarrow[xyz]{abc}'],
      ['\\frac{x}{y}', '\\frac{x}{y}'],
      ['\\xtofrom{abc}', '\\xtofrom{abc}'],
      ['\\rho', '\\rho'],
      ['\\binom{n}{k}', '\\binom{n}{k}'],
    ];

    const enableExtendedFormulas = quillExtendedFormulas();
    enableExtendedFormulas(this.editor, {
      operators: (windowOptions && windowOptions.organization.formula_operators) || formulaOperators,
      supportLink: {
        text: i18n.__('editor_katex_link'),
        url: (window.editor || window.viewer || window.tp).options.katexUrl,
      },
      preview: true,
    });

    const quill = this.editor;

    if (this.options.locked || this.state === 'done' || this.state === 'accepted') {
      $('.ql-editor').attr('data-placeholder', '');
    }

    if (!this.options.limitedEditor) {
      addInsertPickerCustomizations();
      addTextSizeCustomizations();
      addLinkClickHandlers();
      addTooltips();
      if ($(this.$el).hasClass('student')) {
        this.toggleToolBarButtons();
      }
    }

    this.editor.on('text-change', (delta) => {
      const linkUpdate = delta.filter((d) => d && d.attributes && d.attributes.link).length;
      if (linkUpdate) {
        addLinkClickHandlers();
      }
    });

    this.editor.clipboard.addMatcher(Node.TEXT_NODE, (node, delta) => {
      if (node.data.match(/^http(s)*\:\/\//)) {
        if (node.data.match(/jp(e)*g|gif|png|webp/)) {
          return { ops: [{ insert: { image: node.data } }, { insert: '\n' }] };
        } else {
          return { ops: [{ insert: { oembed: { url: node.data, newEmbed: true } } }] };
        }
      } else if (node.data.match(/<iframe.*?s*src="http(.*?)".*?<\/iframe>/)) {
        return { ops: [{ insert: { iframe: node.data } }] };
      } else {
        delta.ops = delta.ops.map((el) => {
          if (el.insert && el.insert.normalize) {
            el.insert = el.insert.normalize();
          }
          return el;
        });
        return delta;
      }
    });

    let edit = this.$el.querySelector('.ql-editor');

    const trimExtraNewLines = () => {
      const length = this.options.limitedEditor ? 2 : 4;
      const endOfContent = quill.getText(quill.getLength() - length, length);
      if (endOfContent === '\n'.repeat(length)) {
        quill.deleteText(quill.getLength() - 2, 2);
      }
    };
    trimExtraNewLines();

    if (!this.options.locked) {
      this.editor.on(Quill.events.EDITOR_CHANGE, function (eventType, range) {
        if (eventType !== Quill.events.SELECTION_CHANGE) return;
        if (range == null) return;
        if (quill.options.readOnly) {
          return;
        }
      });
    }

    if ($('.lp--loopEditor .ql-toolbar').length === 1) {
      $('.lp--loopEditor .ql-toolbar').addClass('show');
    }

    edit.addEventListener('quill-embed-load', () => {
      this.$emit('updateContent', edit.innerHTML);
    });

    edit.addEventListener('templateSelected', () => {
      this.$emit('updateContent', edit.innerHTML);
    });

    this.editor.on('text-change', () => {
      this.$emit('updateContent', edit.innerHTML);
    });

    this.editor.on('selection-change', (range) => {
      this.$emit('selection-change', range);
      if (!range) {
        this.$emit('blur', this.quill);
        setTimeout(() => $('body').removeAttr('data-quill-focus'), 100);
      } else {
        this.$emit('focus', this.quill);
        $('body').attr('data-quill-focus', true);
      }
    });

    if (!this.options.editorPopup && window.editor) {
      this.editor.root.addEventListener('focus', (ev) => {
        const isInsideEditor = $(ev.target).closest('.lp--activityEditor').length > 0;
        if (isInsideEditor) {
          this.toggleToolbar(true, this.editor);
        }
      });

      this.editor.root.addEventListener('blur', (ev) => {
        const isInsideEditor = $(ev.target).closest('.lp--activityEditor').length > 0;
        if (!isInsideEditor) {
          this.toggleToolbar(false, this.editor);
        }
      });
    }

    if (this.pendingFileInsert) {
      this.insertFile(this.pendingFileInsert);
    }

    $(this.editor.container)
      .parent()
      .find('.ql-emoji')
      .on(Utils.tapInteractionEvent, () => {
        $('.tool-container').hide();
        const observer = new MutationObserver(() => {
          quill.setSelection(quill.getLength(), Quill.sources.SILENT);
          quill.focus();
          observer.disconnect();
        });

        observer.observe($('.ql-editor')[0], {
          childList: true,
          subtree: true,
        });
      });

    $(this.editor.container)
      .parent()
      .find('.ql-color-picker')
      .on(Utils.tapInteractionEvent, () => {
        $('.tool-container').hide();
        this.editor.getSelection(true);
      });

    $(this.editor.container)
      .parent()
      .find('.ql-align')
      .on('mouseup', () => {
        $('.tool-container').hide();
        this.editor.getSelection(true);
      });

    const setTooltipArrowPosition = () => {
      $('.tool-container').hide();
      const tooltip = $('.ql-tooltip.ql-editing');
      if (tooltip) {
        const range = this.editor.getSelection(true);
        const bounds = this.editor.getBounds(range.index, range.length);
        const tootipLeft = tooltip.position() ? tooltip.position().left : 0;
        const position = bounds.width / 2 + bounds.left + tootipLeft / 2;
        tooltip.css('--arrowPosition', `${position}px`);
        if (position < 20) {
          const newPosition = Math.max(position + 23, 23);
          tooltip.css({ transform: 'translateX(-20px)', '--arrowPosition': `${newPosition}px` });
        }
      }
    };

    $(this.editor.container)
      .parent()
      .find('.ql-link')
      .on(Utils.interactionEvent, () => {
        setTooltipArrowPosition();
      });
  },
  watch: {
    content: function (newVal) {
      if (this.editor && !this.useAutoSave) {
        if (newVal == ' ') {
          this.editor.setContents([{ insert: '' }]);
        } else {
          this.editor.pasteHTML(newVal ? newVal : '');
        }
      }
    },
    pendingFileInsert: function (newValue) {
      this.insertFile(newValue);
    },
  },
  beforeDestroy: function () {
    this.editor = null;
  },
});

Vue.component('header-toolbar', {
  props: ['options', 'state', 'uuid'],
  template: `
    <div tabindex="0" v-if="shouldShowToolbarButton()" class="header-toolbar">
      <div tabindex="0" class="toolbar-button attachment" v-on:click="addAttachment" v-on:keyup.enter="addAttachment" :title="i18n('editor_tooltip_upload_file')"></div>
      <div tabindex="0" class="toolbar-button video" v-on:click="uploadVideo" v-on:keyup.enter="uploadVideo" :title="i18n('editor_tooltip_record_video')"></div>
      <div tabindex="0" class="toolbar-button audio" v-on:click="uploadAudio" v-on:keyup.enter="uploadAudio" :title="i18n('editor_tooltip_record_audio')"></div>
      <div tabindex="0" class="toolbar-button toggle" v-on:click="toggleToolbar" v-on:keyup.enter="toggleToolbar" :title="toolbarButtonTooltip()"></div>
    </div>
  `,
  mounted: function () {
    this.toolbarVisible = false;
  },
  methods: {
    shouldShowToolbarButton: function () {
      return !this.options.isTeacher && !this.options.locked && this.state !== 'done' && this.state !== 'accepted';
    },
    toggleToolBarButtons: function () {
      $('.ql-toolbar *').prop('disabled', true);
      $('.ql-toolbar.show *').prop('disabled', false);
      $('.ql-toolbar .ql-picker-label').attr('tabindex', -1);
      $('.ql-toolbar.show .ql-picker-label').attr('tabindex', 0);
    },
    toggleToolbar: function (force, editor) {
      this.toolbarVisible = !this.toolbarVisible;
      let container;
      if (editor) {
        container = $(editor.container).closest('.lp--activityEditorContainer');
      } else {
        if (this.uuid) {
          container = $(`.lp--activityEditorContainer[data-uuid="${this.uuid}"]`);
        }
        if (!container || container.length === 0) {
          container = $(`.lp--activityEditorContainer:not([data-uuid]`);
        }
      }

      if (typeof force === 'boolean') {
        $('.panel-content').find('.ql-toolbar').removeClass('show').attr('aria-hidden', true);
        if (force) {
          container.find('.ql-toolbar').addClass('show').removeAttr('aria-hidden');
        }
      } else {
        container.find('.ql-toolbar, .toolbar-button.toggle').toggleClass('show').removeAttr('aria-hidden');
      }
      this.toggleToolBarButtons();
      $('.toolbar-button.toggle').attr('title', this.toolbarButtonTooltip()).blur();
    },
    i18n: function (str) {
      return i18n.__(str);
    },
    addAttachment: function (ev) {
      $(ev.target).blur();
      this.$emit('addAttachment');
    },
    uploadVideo: function (ev) {
      $(ev.target).blur();
      this.$emit('uploadRecording', 'video');
    },
    uploadAudio: function (ev) {
      $(ev.target).blur();
      this.$emit('uploadRecording', 'audio');
    },
    toolbarButtonTooltip: function () {
      return this.toolbarVisible ? i18n.__('editor_tooltip_hide_toolbar') : i18n.__('editor_tooltip_show_toolbar');
    },
  },
});

Vue.component('editor-header', {
  props: ['user', 'header', 'options', 'state', 'type', 'uuid', 'isDefaultEditor'],
  template: `
  <header class="lp--activityEditorSectionHeader">
    <div class="editor-header-row">
      <div class="editor-header-row__left">
        <div class="lp--userAvatar" v-bind:style="{'background-image':'url('+user.image+')'}"></div>
        <div class="header-user-name">{{ user.full_name }}</div>
        <div class="header-time"><time>{{header.date}}</time></div>
      </div>
      <div class="editor-header-row__right">
        <header-toolbar :options="this.options" :state="this.state" :uuid="this.uuid" v-on:addAttachment="addAttachment" v-on:uploadRecording="uploadRecording" />
        <div tabindex="0" v-if="showRequestFeedbackButton()" class="request-feedback" v-on:click="requestFeedback" v-on:keyup.enter="requestFeedback"></div>
        <activity-editor-comment v-if="!showRequestFeedbackButton()" @commentRequested="commentRequested"/>
      </div>
    </div>
  </header>
  `,
  mounted: function () {
    this.toolbarVisible = false;
  },
  methods: {
    stateChanged: function (state) {
      this.$emit('stateChanged', state);
    },
    i18n: function (str) {
      return i18n.__(str);
    },
    commentRequested: function () {
      this.$emit('commentRequested');
    },
    addAttachment: function () {
      this.$emit('addAttachment');
    },
    uploadRecording: function (type) {
      this.$emit('uploadRecording', type);
    },
    requestFeedback: function (ev) {
      $(ev.target).blur();
      this.stateChanged('feedback');
      this.commentRequested();
    },
    showRequestFeedbackButton: function () {
      return (
        !this.options.locked &&
        (this.type !== 'logbook' || this.isDefaultEditor) &&
        this.state !== 'done' &&
        this.state !== 'accepted'
      );
    },
  },
});

Vue.component('editor-header-group', {
  props: ['user', 'header', 'options', 'state', 'uuid'],
  template: `
    <header class="lp--activityEditorSectionHeader">
      <div class="editor-header-row group">
        <div class="editor-header-row__left ">
          <div class="lp--userAvatar" v-for="participation in header.participants" v-bind:title="participation.User.first_name + ' ' + participation.User.last_name" v-bind:style="{'background-image':'url('+participation.User.image+')'}"></div>
        </div>
        <div class="editor-header-row__right">
          <header-toolbar :options="this.options" :state="this.state" :uuid="this.uuid" v-on:addAttachment="addAttachment" v-on:uploadRecording="uploadRecording" />
          <div tabindex="0" v-if="showRequestFeedbackButton()" class="request-feedback" v-on:click="requestFeedback" v-on:keyup.enter="requestFeedback"></div>
          <activity-editor-comment v-if="!showRequestFeedbackButton()" @commentRequested="commentRequested"/>
        </div>
      </div>
    </header>
  `,
  methods: {
    stateChanged: function (state) {
      this.$emit('stateChanged', state);
    },
    i18n: function (str) {
      return i18n.__(str);
    },
    commentRequested: function () {
      this.$emit('commentRequested');
    },
    addAttachment: function () {
      this.$emit('addAttachment');
    },
    uploadRecording: function (type) {
      this.$emit('uploadRecording', type);
    },
    requestFeedback: function (ev) {
      $(ev.target).blur();
      this.stateChanged('feedback');
      this.commentRequested();
    },
    showRequestFeedbackButton: function () {
      return !this.options.locked && this.state !== 'done' && this.state !== 'accepted';
    },
  },
});

Vue.component('editor-header-qa', {
  props: ['user', 'header', 'options', 'state', 'uuid'],
  template: `
    <header class="lp--activityEditorSectionHeader lp--activityEditorSectionHeaderWrittenQuiz">
      <div class="editor-header-row">
        <div class="editor-header-row__left">
          <div class="lp--activityEditorSectionHeaderWrapper">
            <div class="lp--activityEditorHeaderQuestionBody" v-html="header.body"></div>
          </div>
        </div>
        <div class="editor-header-row__right">
          <header-toolbar :options="this.options" :state="this.state" :uuid="this.uuid" v-on:addAttachment="addAttachment" v-on:uploadRecording="uploadRecording" />
          <div tabindex="0" v-if="showRequestFeedbackButton()" class="request-feedback" v-on:click="requestFeedback" v-on:keyup.enter="requestFeedback"></div>
          <activity-editor-comment v-if="!showRequestFeedbackButton()" @commentRequested="commentRequested"/>
        </div>
      </div>
    </header>
  `,
  methods: {
    stateChanged: function (state) {
      this.$emit('stateChanged', state);
    },
    i18n: function (str) {
      return i18n.__(str);
    },
    commentRequested: function () {
      this.$emit('commentRequested');
    },
    addAttachment: function () {
      this.$emit('addAttachment');
    },
    uploadRecording: function (type) {
      this.$emit('uploadRecording', type);
    },
    requestFeedback: function (ev) {
      $(ev.target).blur();
      this.stateChanged('feedback');
      this.commentRequested();
    },
    showRequestFeedbackButton: function () {
      return !this.options.locked && this.state !== 'done' && this.state !== 'accepted';
    },
  },
});

Vue.component('editor-state-selector', {
  props: {
    options: {
      inert: false,
    },
    state: {},
    expanded: {
      default: false,
    },
    showHelp: {
      default: true,
    },
    allowLock: {
      default: false,
    },
    locked: {},
    allowStates: {
      default: true,
    },
    isTeacher: {
      default: false,
    },
  },
  template: `  
  <div class="lp--activityEditorStateContainer">
  {{labelForState}}
  <a href="#" v-on:click="toggleExpanded" class="lp--activityEditorStateSwitch" v-bind:class="dynamicWrapperClasses()" :title="i18n('set_editor_state')">
    <div class="lp--activityStateSwitchList">
      <ul>
        <li tabindex="0" v-if="allowStates && availableState.event != 'done'" v-for="availableState in availableStates" v-on:click.stop="stateChanged(availableState)" v-on:keyup.enter="stateChanged(availableState)" class="lp--activityEditorStateItem" v-bind:class="dynamicClasses(availableState.event)">        
          <div class="lp--activityEditorStateItemLabel">
            {{i18n('editor_state_'+(availableState.label ? availableState.label : availableState.event))}}
          </div>
          <div class="lp--activityEditorStateItemIcon"></div>
        </li>
        <template v-if="allowLock">
          <li tabindex="0" v-if="locked" class="lp--activityEditorStateItem lp--activityEditorStateItemUnlock"  v-on:click.stop="lockChanged(false)" v-on:keyup.enter="lockChanged(false)">
            <div class="lp--activityEditorStateItemLabel">{{i18n('editor_state_unlock')}}</div>
            <div class="lp--activityEditorStateItemIcon"></div>
          </li>
          <li tabindex="0" v-if="!locked" class="lp--activityEditorStateItem lp--activityEditorStateItemLock" v-on:click.stop="lockChanged(true)" v-on:keyup.enter="lockChanged(true)">
            <div class="lp--activityEditorStateItemLabel">{{i18n('editor_state_lock')}}</div>
            <div class="lp--activityEditorStateItemIcon"></div>
          </li>
        </template>
      </ul>
    </div>
  </a>
  </div>
  `,
  mounted: function () {
    $(document).on('click', (ev) => {
      if (!ev.target.classList.contains('lp--activityEditorStateSwitch')) {
        this.expanded = false;
      }
    });
  },
  computed: {
    helpLinkURL: function () {
      return this.options.help.activity.state;
    },
    availableStates: function () {
      return Utils.getAvailableBehaviorStates(this.state, this.isTeacher);
    },
    labelForState: function () {
      return i18n.__(Utils.getStateLabelString(this.state));
    },
  },
  methods: {
    dynamicWrapperClasses: function () {
      let list = { 'lp--activityEditorStateSwitchExpanded': this.expanded };
      list['lp--activityEditorStateSwitch' + this.state] = true;
      list['lp--activityEditorStateSwitchInert'] = this.options.inert;
      return list;
    },
    dynamicClasses: function (cl) {
      let list = {
        'lp--activityEditorStateItemCurrent': cl.event == this.state,
        'lp--activityEditorStateItemTeacher': this.isTeacher,
      };
      list['lp--activityEditorStateItem' + cl] = true;
      return list;
    },
    i18n: function (str) {
      if (this.isTeacher) {
        return i18n.__(str + '_teacher');
      } else {
        return i18n.__(str);
      }
    },
    toggleExpanded: function () {
      if (this.options.inert) {
        return;
      }
      this.expanded = !this.expanded;
    },
    lockChanged: function (locked) {
      this.expanded = false;
      this.locked = locked;
      this.$emit('stateChanged', this.state, this.locked);
    },
    stateChanged: function (state) {
      this.expanded = false;
      if (state.event == 'accept') {
        this.locked = true;
      } else if (state.event == 'active') {
        this.locked = false;
      }
      this.state = state.event;
      this.$emit('stateChanged', this.state, this.locked);
    },
  },
});

Vue.component('activity-editor-locked-notification', {
  template: `
    <div class="lp--activityEditorLocked">{{i18n('editor_locked_desc')}}</div>
  `,
  methods: {
    i18n: function (str) {
      return i18n.__(str);
    },
  },
});

Vue.component('activity-editor-comment', {
  template: `<a href="#" class="lp--activityEditorHeaderComment" @click="triggerComment" :title="i18n('app_comment')" :aria-label="i18n('app_comment')"></a>`,
  methods: {
    triggerComment: function (ev) {
      $(ev.target).blur();
      this.$emit('commentRequested');
    },
    i18n: function (str) {
      return i18n.__(str);
    },
  },
});

Vue.component('main-editor', {
  template: `<div></div>`,
});

Vue.component('comment-texteditor', {
  props: ['options'],
  template: `    
      <div class="lp--activityEditorArea lp--commentEditorArea lp--js-editor"></div>  
    `,
  mounted: function () {
    this.editor = new Quill(this.$el, {
      theme: 'bubble',
      placeholder: this.options.placeholder ? this.options.placeholder : i18n.__('comment_texteditor_placeholder'),
      readOnly: this.options.locked,
      modules: {
        toolbar: ['bold', 'italic', 'underline'],
        keyboard: {
          bindings: {
            tab: {
              key: 9,
              handler: () => {
                return true;
              },
            },
          },
        },
        imageResize: {
          modules: ['Resize', 'DisplaySize', 'Toolbar', ImageAttribute],
        },
      },
    });

    this.editor.clipboard.addMatcher(Node.TEXT_NODE, function (node, delta) {
      if (node.data.match(/^http(s)*\:\/\//)) {
        if (node.data.match(/jp(e)*g|gif|png|webp/)) {
          return { ops: [{ insert: { image: node.data } }, { insert: '\n' }] };
        } else {
          return { ops: [{ insert: { oembed: { url: node.data, comment: true } } }] };
        }
      } else {
        delta.ops = delta.ops.map(function (el) {
          if (el.insert && el.insert.normalize) {
            el.insert = el.insert.normalize();
          }
          return el;
        });
        return delta;
      }
    });

    let edit = this.$el.querySelector('.ql-editor');
    this.editor.on('text-change', () => {
      this.$emit('updateContent', edit.innerHTML);
    });

    this.editor.on('selection-change', (range) => {
      let isBlurred = range == null;
      this.$emit('editorStateChanged', isBlurred);
    });

    edit.addEventListener('quill-embed-load', () => {
      this.$emit('updateContent', edit.innerHTML);
    });
  },
  methods: {
    clear: function () {
      this.editor.setText('');
      this.$emit('editorStateChanged', true);
    },
    blur: function () {
      if (!this.editor) {
        this.editor.blur();
      }
    },
  },
});

Vue.component('comment-editor', {
  props: {
    item: {},
    user: {},
    options: {},
    header: {},
    type: '',
    displayRecorder: false,
    recordingType: '',
    uploading: false,
    pendingFileInsert: false,
    messageTypePickerExpanded: true,
    animating: false,
  },
  methods: {
    blur: function () {
      if (this.$refs.text_editor) {
        this.$refs.text_editor.blur();
      }
    },
    clear: function () {
      if (this.$refs.text_editor) {
        this.$refs.text_editor.clear();
      }
      this.item.attachments = [];
      this.item.type = '';
      this.pendingFileInsert = false;
    },
    setAnimating: function () {
      this.animating = true;
      setTimeout(() => {
        this.animating = false;
      }, 500);
    },
    toggleMessageTypePicker: function () {
      this.setAnimating();
      if (!this.messageTypePickerExpanded) {
        this.messageTypePickerExpanded = true;
      }
    },
    updateContent: function (cnt, writeNow) {
      if (writeNow) {
        this.item.body = cnt;
      }
      this.$emit('updateContent', cnt);
    },
    publishRecording: function () {
      if (this.$refs.recorder) {
        return this.$refs.recorder.publishRecording();
      }
    },
    setActiveState: function (blur) {
      this.setAnimating();
      this.messageTypePickerExpanded = blur;
    },
    useRecorder: function (type) {
      this.recordingType = type;
      this.toggleRecorder();
    },
    toggleRecorder: function (force) {
      if (typeof force != 'undefined') {
        this.displayRecorder = force;
      } else {
        this.displayRecorder = !this.displayRecorder;
      }
      if (this.displayRecorder) {
        $('.lp--activityEditorRecorder').show();
      }
      this.$emit('recorderStateChanged', this.displayRecorder);
    },
    recordingDone: function (ev) {
      this.$emit('recordingDone', ev);
    },
    hideProcessingScreen: function (data) {
      let mediaSelector = data.type === 'Video' ? '.lp--webcamRecording' : '.lp--audioRecording';
      mediaSelector += `[data-uuid="${data.uuid}"]`;
      if ($(mediaSelector).length > 0) {
        $(mediaSelector).closest(data.type).removeAttr('poster')[0].load();
      }
    },
    recordingProcessed: function (data) {
      this.hideProcessingScreen(data);
      this.toggleRecorder(false);
    },
    fileUploadFail: function () {
      flash(i18n.__('error_file_upload_failed'));
    },
    fileUploadDone: function (data) {
      this.messageTypePickerExpanded = false;
      this.pendingFileInsert = data.result;
      this.item.type = 'file';
      this.item.attachments.push({
        url: this.options.upload.url + data.result.filename,
        thumb: this.options.upload.url + data.result.filename,
        filename: data.result.original_filename,
        mime_type: data.result.filemime,
        source: ActivityEditor.AttachmentSource.Upload,
      });
    },
    discardType: function () {
      this.toggleRecorder(false);
      this.pendingFileInsert = null;
      this.item.type = null;
    },
    getTabIndex: function () {
      return this.messageTypePickerExpanded ? -1 : 0;
    },
  },
  template: `
  <section class="lp--activityEditorSection lp--commentEditorSection">
    <editor-recorder ref="recorder" @recordingDone="recordingDone" @recordingProcessed="recordingProcessed" v-if="displayRecorder" v-on:toggleRecorder="toggleRecorder" @discardType="discardType" :type="recordingType" :options="options" />
    <comment-file-preview v-if="this.pendingFileInsert" :file="this.pendingFileInsert" @discardType="discardType" />
    <div class="lp--activityEditor lp--commentEditor" v-else>
      <comment-texteditor ref="text_editor" :type="type" :options="options" :content="item.body" v-on:updateContent="updateContent" @editorStateChanged="setActiveState"/>
      <div v-bind:tabindex="getTabIndex()" class="lp--commentEditorMessageTypePicker" v-bind:class="{'open': this.messageTypePickerExpanded, 'animating': this.animating}" v-on:click.self="toggleMessageTypePicker" v-on:keyup.enter="toggleMessageTypePicker">
        <editor-file-picker v-on:fileUploadFail="fileUploadFail" v-on:fileUploadDone="fileUploadDone" :options="options" :isComment="true" @useRecorder="useRecorder" :hideTools="!this.messageTypePickerExpanded" />
      </div>
    </div>
  </section>
  `,
});

Vue.component('comment-file-preview', {
  props: ['file'],
  methods: {
    closePreview: function () {
      this.$emit('discardType');
    },
    i18n: function (str) {
      return i18n.__(str);
    },
  },
  template: `
    <div class="lp--commentEditorFilePreview">
      <a href="#" v-on:click="closePreview" class="lp--closeButton" v-bind:title="i18n('app_close')"></a>
      <h4 class="lp--commentEditorFilePreviewTitle">
      {{this.file.original_filename}}
      </h4>
    </div>
  `,
});

Vue.component('activity-editor', {
  props: {
    item: {},
    user: {},
    options: {},
    header: {},
    type: '',
    displayRecorder: false,
    recordingType: '',
    uploading: false,
    active: false,
    pendingFileInsert: false,
    isDefaultEditor: true,
  },
  mounted: function () {
    $(window).on('media.processed', (ev, data) => {
      this.hideProcessingScreen(data);
    });
    this.isActive = this.active;
  },
  methods: {
    fileAdded: function (file) {
      this.pendingFileInsert = file;
    },
    blur: function () {
      if (this.$refs.text_editor) {
        this.$refs.text_editor.blur();
      }
    },
    focus: function () {
      if (this.$refs.text_editor) {
        this.$refs.text_editor.focus();
      }
    },
    disable: function () {
      this.$refs.text_editor.disable();
    },
    enable: function () {
      this.$refs.text_editor.enable();
    },
    fileUploadFail: function () {
      flash(i18n.__('error_file_upload_failed'));
    },
    attachmentAdded: function (file) {
      this.item.attachments.push(file);
      this.$emit('dirtyStateChange');
    },
    fileUploadDone: function (data) {
      const file = {
        url: this.options.upload.url + data.result.filename,
        thumb: this.options.upload.url + data.result.filename,
        filename: data.result.original_filename,
        mime_type: data.result.filemime,
        source: ActivityEditor.AttachmentSource.Upload,
      };
      if (
        !this.item.attachments.find((attachment) => {
          return attachment.filename === file.filename;
        })
      ) {
        this.item.attachments.push(file);
        this.$emit('dirtyStateChange');
      }
    },
    removeAttachment: function (attachment) {
      let index = this.item.attachments.indexOf(attachment);
      if (attachment.id) {
        if (!this.item.deleted_attachments) {
          this.item.deleted_attachments = [];
        }
        this.item.deleted_attachments.push(attachment.id);
      }
      Vue.delete(this.item.attachments, index);
      this.$emit('dirtyStateChange');
    },
    useRecorder: function (type) {
      this.recordingType = type;
      this.toggleRecorder();
    },
    toggleRecorder: function (force) {
      if (force) {
        this.displayRecorder = force;
      } else {
        this.displayRecorder = !this.displayRecorder;
      }
      this.$emit('recorderStateChanged', this.displayRecorder);
    },
    updateContent: function (cnt, writeNow) {
      if (writeNow) {
        this.item.body = cnt;
      }
      this.$emit('updateContent', cnt);
      this.$emit('dirtyStateChange');
    },
    setActiveState: function (blur) {
      this.isActive = !blur;
    },
    stateChanged: function (state) {
      this.item.state = state;
      this.$emit('stateChanged', state);
    },
    commentRequested: function () {
      this.$emit('comment');
    },
    addAttachment: function () {
      this.$refs.text_editor.addAttachment();
    },
    uploadRecording: function (type) {
      this.$refs.text_editor.uploadRecording(type);
    },
    hideProcessingScreen: function (data) {
      let mediaSelector = data.type === 'Video' ? '.webcam' : '.microphone';
      mediaSelector += `[data-uuid="${data.uuid}"]`;
      if ($(mediaSelector).length > 0) {
        $(mediaSelector).removeAttr('data-state').children(data.type).removeAttr('poster')[0].load();
      }
    },
    recordingProcessed: function (data) {
      this.hideProcessingScreen(data);
      this.toggleRecorder(false);
    },
  },
  computed: {
    currentHeader: function () {
      switch (this.type) {
        case 'task':
        case 'evaluation':
        case 'logbook':
        case 'noticeboard':
          return 'editor-header';
        case 'group':
          return 'editor-header-group';
        case 'written_quiz':
          return 'editor-header-qa';
      }
    },
    hasBeenPersisted: function () {
      return !!this.item.uuid;
    },
  },
  beforeDestroy: function () {
    $(window).off('media.processed');
  },
  template: `
    <section class="lp--activityEditorSection" v-bind:class="{ 'student': !this.options.isTeacher }">
      <editor-recorder ref="recorder" v-if="displayRecorder" v-on:toggleRecorder="toggleRecorder" @recordingProcessed="recordingProcessed" v-on:fileAdded="fileAdded" :type="recordingType" :options="options" />
      <component :is="currentHeader" :type="this.type" :isDefaultEditor="this.isDefaultEditor" :isTeacher="this.options.isTeacher" :user="user" :header="header" :hasBeenPersisted="hasBeenPersisted" :state="item.state" :options="options" v-on:addAttachment="addAttachment" v-on:uploadRecording="uploadRecording" v-on:commentRequested="commentRequested" v-on:stateChanged="stateChanged" :uuid="item.uuid"></component>
      <editor-texteditor ref="text_editor" :hasattachments="item.attachments.length > 0" :state="item.state" :pendingFileInsert="pendingFileInsert" v-on:attachmentAdded="attachmentAdded" v-on:fileUploadFail="fileUploadFail" v-on:fileUploadDone="fileUploadDone" :type="type" :isTeacher="this.options.isTeacher" :options="options" :content="item.body" :uuid="item.uuid" v-on:updateContent="updateContent" @editorStateChanged="setActiveState" @useRecorder="useRecorder" :toggleRecorder="toggleRecorder"/>
      <div class="lp--activityEditorAttachments" v-if="item.attachments.length > 0">
        <editor-attachment v-for="(attachment, index) in item.attachments" :key="index" :locked="options.locked" :attachment="attachment" v-on:remove="removeAttachment" />
      </div>
      <activity-editor-locked-notification v-if="options.locked" />
    </section>
  `,
});
